const Swiper = require("swiper");

window.addEventListener("load", init);

gsap.registerPlugin(ScrollTrigger);

// gsap.set(".home-slider .inner img", {
//   x: 200,
// });

function init(e) {
  console.log("Engines on.");

  const aniSlider = gsap.fromTo(
    ".home-slider .inner img",
    { x: 200, opacity: 0 },
    {
      x: 0,
      opacity: 1,
      duration: 1.5,
      ease: "elastic.out(1, 0.5)",
    }
  );

  if (document.querySelector(".home-slider .inner img")) {
    aniSlider.restart();
  }

  if (document.querySelector(".numbers .col1")) {
    gsap.fromTo(
      ".numbers .col1",
      { x: -100, opacity: 0 },
      {
        x: 0,
        opacity: 1,
        duration: 0.6,
        scrollTrigger: {
          trigger: ".numbers",
          start: "top+=180px bottom",
        },
      }
    );
    gsap.fromTo(
      ".numbers .col2",
      { y: -100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.6,
        scrollTrigger: {
          trigger: ".numbers",
          start: "top+=180px bottom",
        },
      }
    );
    gsap.fromTo(
      ".numbers .col3",
      { x: 100, opacity: 0 },
      {
        x: 0,
        opacity: 1,
        duration: 0.6,
        scrollTrigger: {
          trigger: ".numbers",
          start: "top+=180px bottom",
        },
      }
    );
  }

  // if (document.querySelector(".seja .col")) {
  //   gsap.from(".seja .col", {
  //     y: 100,
  //     opacity: 0,
  //     stagger: 0.1,
  //     duration: 0.8,
  //     scrollTrigger: {
  //       trigger: ".seja",
  //       start: "top top",
  //       toggleActions: "play none play reset",
  //     },
  //   });
  // }

  if (document.querySelector(".novidade-card")) {
    gsap.from(".novidade-card", {
      y: 100,
      opacity: 0,
      stagger: 0.1,
      duration: 0.8,
      scrollTrigger: {
        trigger: ".novidades-grid",
        start: "top bottom",
        toggleActions: "play none play reset",
      },
    });
  }

  const header = document.querySelector(".main-header");
  const mobileNav = document.querySelector(".mobile-nav");

  const headerH = header.offsetHeight;

  mobileNav.style.top = headerH + "px";

  console.log(headerH);

  const btnHamburger = document.querySelector(".btn-hamburger");
  // const btnClose = document.querySelector(".btn-close-nav");
  const nav = document.querySelector(".mobile-nav");

  btnHamburger.addEventListener("click", e => {
    e.preventDefault;
    btnHamburger.classList.toggle("is-active");
    nav.classList.toggle("active");
    // document.body.classList.toggle("no-overflow");
  });
  // btnClose.addEventListener("click", e => {
  //   e.preventDefault;
  //   btnHamburger.classList.toggle("is-active");
  //   nav.classList.toggle("active");
  //   document.body.classList.toggle("no-overflow");
  // });

  const btnSearch = [...document.querySelectorAll(".btn-search")];
  const btnCloseSearch = document.querySelector(".btn-close-search");
  const searchBox = document.querySelector(".search-box");

  btnSearch.forEach(el => {
    el.addEventListener("click", e => {
      e.preventDefault;
      searchBox.classList.toggle("active");
      // document.body.classList.toggle("no-overflow");
    });
  });
  btnCloseSearch.addEventListener("click", e => {
    e.preventDefault;
    searchBox.classList.toggle("active");
    // document.body.classList.toggle("no-overflow");
  });

  const HomeMainSlider = document.querySelector('[data-carousel="home-main"]');

  if (HomeMainSlider) {
    const MainCarousel = new Swiper(HomeMainSlider, {
      speed: 400,
      // loop: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchOverflow: true,
      spaceBetween: 60,
      navigation: {
        nextEl: document.querySelector(".home-slider .swiper-button-next"),
        prevEl: document.querySelector(".home-slider .swiper-button-prev"),
      },
      pagination: {
        el: document.querySelector(".home-slider .swiper-pagination"),
        type: "bullets",
        renderBullet: (index, className) => `<button class="${className}" type="button" aria-title="${index}">
      </button>`,
        clickable: true,
      },
    });

    MainCarousel.on("slideChange", function () {
      aniSlider.restart();
    });
  }

  const HomeCotacoesSlider = document.querySelector('[data-carousel="home-cotacoes"]');

  if (HomeCotacoesSlider) {
    const Carousel = new Swiper(HomeCotacoesSlider, {
      speed: 400,
      // loop: true,
      slidesPerView: 2,
      slidesPerGroup: 1,
      watchOverflow: true,
      spaceBetween: 0,

      navigation: {
        nextEl: document.querySelector(".home-cotacoes .swiper-button-next"),
        prevEl: document.querySelector(".home-cotacoes .swiper-button-prev"),
      },
      pagination: {
        el: document.querySelector(".home-cotacoes .swiper-pagination"),
        type: "bullets",
        renderBullet: (index, className) => `<button class="${className}" type="button" aria-title="${index}">
        </button>`,
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 15,
        },
      },
    });
  }

  const PremissasSlider = document.querySelector('[data-carousel="slider-premissas"]');

  if (PremissasSlider) {
    const Carousel = new Swiper(PremissasSlider, {
      speed: 400,
      // loop: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchOverflow: true,
      spaceBetween: 30,
      navigation: {
        nextEl: document.querySelector(".slider-premissas .swiper-button-next"),
        prevEl: document.querySelector(".slider-premissas .swiper-button-prev"),
      },
      pagination: {
        el: document.querySelector(".slider-premissas .swiper-pagination"),
        type: "bullets",
        renderBullet: (index, className) => `<button class="${className}" type="button" aria-title="${index}">
        </button>`,
        clickable: true,
      },
    });
  }

  const SejaSlider = document.querySelector('[data-carousel="seja-slider"]');

  if (SejaSlider) {
    const Carousel = new Swiper(SejaSlider, {
      speed: 400,
      // loop: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchOverflow: true,
      spaceBetween: 30,
      navigation: {
        nextEl: document.querySelector(".seja-slider .swiper-button-next"),
        prevEl: document.querySelector(".seja-slider .swiper-button-prev"),
      },
      pagination: {
        el: document.querySelector(".seja-slider .swiper-pagination"),
        type: "bullets",
        renderBullet: (index, className) => `<button class="${className}" type="button" aria-title="${index}">
        </button>`,
        clickable: true,
      },
    });
  }

  const ShowSlider1 = document.querySelector('[data-carousel="show-slider1"]');

  if (ShowSlider1) {
    const Carousel = new Swiper(ShowSlider1, {
      speed: 400,
      // loop: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchOverflow: true,
      spaceBetween: 10,
      navigation: {
        nextEl: document.querySelector(".show-slider1 .swiper-button-next"),
        prevEl: document.querySelector(".show-slider1 .swiper-button-prev"),
      },
      pagination: {
        el: document.querySelector(".show-slider1 .swiper-pagination"),
        type: "bullets",
        renderBullet: (index, className) => `<button class="${className}" type="button" aria-title="${index}">
        </button>`,
        clickable: true,
      },
    });
  }

  // const ShowSlider2 = document.querySelector('[data-carousel="show-slider2"]');

  // if (ShowSlider2) {
  //   const Carousel = new Swiper(ShowSlider2, {
  //     speed: 400,
  //     // loop: true,
  //     slidesPerView: 1,
  //     slidesPerGroup: 1,
  //     watchOverflow: true,
  //     spaceBetween: 30,
  //     navigation: {
  //       nextEl: document.querySelector(".show-slider2 .swiper-button-next"),
  //       prevEl: document.querySelector(".show-slider2 .swiper-button-prev"),
  //     },
  //     pagination: {
  //       el: document.querySelector(".show-slider2 .swiper-pagination"),
  //       type: "bullets",
  //       renderBullet: (index, className) => `<button class="${className}" type="button" aria-title="${index}">
  //       </button>`,
  //       clickable: true,
  //     },
  //   });
  // }

  //PARA MÚLTIPLOS CARROSSEIS NA MESMA PÁGINA //

  var allShowSlider2 = document.querySelectorAll(".show-slider2");
  const ShowSlider2 = document.querySelector('[data-carousel="show-slider2"]');

  if (ShowSlider2) {
    for (var elShowSlider2 of allShowSlider2) {
      var nShowSlider2 = Array.prototype.indexOf.call(allShowSlider2, elShowSlider2);
      var carCardIcone = elShowSlider2.querySelector('[data-carousel="show-slider2"]');
      var programasCarreiras = new Swiper(carCardIcone, {
        speed: 400,
        // loop: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        watchOverflow: true,
        spaceBetween: 30,
        navigation: {
          nextEl: elShowSlider2.querySelector(".swiper-button-next"),
          prevEl: elShowSlider2.querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: elShowSlider2.querySelector(".swiper-pagination"),
          type: "bullets",
          renderBullet: (index, className) => `<button class="${className}" type="button" aria-title="${index}">
        </button>`,
          clickable: true,
        },
      });
    }
  }

  const ShowSliderDepoimento = document.querySelector('[data-carousel="show-slider-depoimentos"]');

  if (ShowSliderDepoimento) {
    const Carousel = new Swiper(ShowSliderDepoimento, {
      speed: 400,
      // loop: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchOverflow: true,
      spaceBetween: 30,
      navigation: {
        nextEl: document.querySelector(".show-slider-depoimentos .swiper-button-next"),
        prevEl: document.querySelector(".show-slider-depoimentos .swiper-button-prev"),
      },
      pagination: {
        el: document.querySelector(".show-slider-depoimentos .swiper-pagination"),
        type: "bullets",
        renderBullet: (index, className) => `<button class="${className}" type="button" aria-title="${index}">
        </button>`,
        clickable: true,
      },
    });
  }

  const CarouselTimeline = document.querySelector('[data-carousel="timeline"]');

  if (CarouselTimeline) {
    const Timeline = new Swiper(CarouselTimeline, {
      speed: 400,
      slidesPerView: 3,
      spaceBetween: 0,
      watchOverflow: true,
      navigation: {
        nextEl: ".sobre-timeline .swiper-button-next",
        prevEl: ".sobre-timeline .swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: "auto",
        },
      },
      // pagination: {
      //   el: HomeCarouselConteudos.querySelector('.swiper-pagination'),
      //   type: 'bullets',
      //   renderBullet: (index, className) => `<button class="${className}" type="button" aria-title="${index}">
      //   </button>`,
      //   clickable: true
      // },
    });
  }

  // Get modal element
  const overlay = document.querySelector("#overlay");
  const videoModal = document.querySelector(".modal-video");

  const videoBtn = document.querySelector(".thumb-video");

  if (videoBtn) {
    const videoContent = videoModal.querySelector(".videoWrapper");
    const videoClose = videoModal.querySelector(".ico-close");
    videoBtn.addEventListener("click", openModal);
    videoClose.addEventListener("click", closeModal);
    window.addEventListener("click", outsideClick);

    function openModal(e) {
      e.preventDefault();
      const videoId = e.target.dataset.videoid;

      const video = `<iframe width="560" height="315" src="https://www.youtube.com/embed/${videoId}?rel=0" title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen></iframe>`;

      videoContent.innerHTML = video;

      overlay.classList.add("show");
      videoModal.classList.add("show");
    }

    // Close modal
    function closeModal() {
      overlay.classList.remove("show");
      videoModal.classList.remove("show");
      videoContent.innerHTML = null;
    }

    // Click outside and close
    function outsideClick(e) {
      if (e.target == videoModal) {
        overlay.classList.remove("show");
        videoModal.classList.remove("show");
        videoContent.innerHTML = null;
      }
    }
  }

  function videoDefer() {
    var vidDefer = document.getElementsByTagName("iframe");
    for (var i = 0; i < vidDefer.length; i++) {
      if (vidDefer[i].getAttribute("data-src")) {
        vidDefer[i].setAttribute("src", vidDefer[i].getAttribute("data-src"));
      }
    }
  }

  const formModal = document.querySelector(".modal-cooperado");
  const formBtn = document.querySelectorAll(".btn-form");

  if (formBtn) {
    const videoFormClose = formModal.querySelector(".ico-close");
    formBtn.forEach(el => {
      el.addEventListener("click", openFormModal);
    });

    videoFormClose.addEventListener("click", closeFormModal);

    function openFormModal(e) {
      e.preventDefault();
      formModal.classList.add("show");
    }

    // Close modal
    function closeFormModal() {
      formModal.classList.remove("show");
    }
  }

  const catSelect = document.querySelector("#cat-select");

  const baseUrl = window.location.origin;

  if (catSelect) {
    catSelect.addEventListener("change", e => {
      const newPlace = baseUrl + "/category/" + e.target.value + "/";
      window.location.href = newPlace;
    });
  }

  // const cookiesBar = document.querySelector(".cookies-bar");
  // const cookiesBtn = document.querySelector(".cookies-bar .btn");

  // cookiesBtn.addEventListener("click", e => {
  //   e.preventDefault();
  //   cookiesBar.classList.add("hide");
  // });

  /*==COOKIES==*/

  (function () {
    "use strict";

    var cookieAlert = document.getElementById("cookiealert");
    var acceptCookies = document.getElementById("acceptcookies");

    if (!cookieAlert) {
      return;
    }

    cookieAlert.offsetHeight; // Force browser to trigger reflow (https://stackoverflow.com/a/39451131)

    // Show the alert if we cant find the "acceptCookies" cookie

    if (sessionStorage.getItem("acceptCookies") === null) {
      cookieAlert.classList.add("show");
    } else {
      cookieAlert.classList.remove("show");
    }

    acceptCookies.addEventListener("click", e => {
      e.preventDefault();
      cookieAlert.classList.remove("show");
      sessionStorage.setItem("acceptCookies", "true");
    });

    // Cookie functions from w3schools
    // function setCookie(cname, cvalue, exdays) {
    //   var d = new Date();
    //   d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    //   var expires = "expires=" + d.toUTCString();
    //   document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    // }

    // function getCookie(cname) {
    //   var name = cname + "=";
    //   var decodedCookie = decodeURIComponent(document.cookie);
    //   var ca = decodedCookie.split(";");
    //   for (var i = 0; i < ca.length; i++) {
    //     var c = ca[i];
    //     while (c.charAt(0) === " ") {
    //       c = c.substring(1);
    //     }
    //     if (c.indexOf(name) === 0) {
    //       return c.substring(name.length, c.length);
    //     }
    //   }
    //   return "";
    // }
  })();

  // /*==MENU ACESSIBILIDADE==*/
  // var btA11y = document.querySelector("#a11y .a11y__btn");
  // var wrapperA11y = document.getElementById("a11y");
  // var btFecharA11y = document.querySelector("#a11y .a11y__close");

  // btA11y.addEventListener("click", abrirA11y);
  // btFecharA11y.addEventListener("click", fecharA11y);

  // function abrirA11y() {
  //   wrapperA11y.classList.add("active");
  // }

  // function fecharA11y() {
  //   wrapperA11y.classList.remove("active");
  // }

  // Accessibility

  // sessionStorage.getItem("contrast") && +sessionStorage.getItem("contrast") && document.body.classList.add("has--high-contrast");

  // if (document.querySelector("[data-contrast]")) {
  //   document.querySelector("[data-contrast]").addEventListener(
  //     "click",
  //     () => {
  //       console.log("contraste");
  //       document.body.classList.toggle("has--high-contrast");

  //       sessionStorage.setItem("contrast", document.body.classList.contains("has--high-contrast") ? 1 : 0);
  //     },
  //     true
  //   );
  // }

  // if (sessionStorage.getItem("fontsize")) document.body.style.fontSize = sessionStorage.getItem("fontsize") + "px";

  // if (document.querySelector("[data-fontsize-decrease]")) {
  //   document.querySelector("[data-fontsize-decrease]").addEventListener(
  //     "click",
  //     event => {
  //       event.preventDefault();
  //       let fontsize = parseInt(window.getComputedStyle(document.body, null).getPropertyValue("font-size"));

  //       if (fontsize > 14) {
  //         document.body.style.fontSize = --fontsize + "px";
  //         sessionStorage.setItem("fontsize", fontsize);
  //       }
  //     },
  //     true
  //   );
  // }

  // if (document.querySelector("[data-fontsize-increase]")) {
  //   document.querySelector("[data-fontsize-increase]").addEventListener(
  //     "click",
  //     event => {
  //       event.preventDefault();
  //       let fontsize = parseInt(window.getComputedStyle(document.body, null).getPropertyValue("font-size"));

  //       if (fontsize < 18) {
  //         document.body.style.fontSize = ++fontsize + "px";
  //         sessionStorage.setItem("fontsize", fontsize);
  //       }
  //     },
  //     true
  //   );
  // }

  const stateSelect = document.querySelector("#estado");
  const citySelect = document.querySelector("#cidade");

  // ############################### GET TODAY'S DATE + 4 DAYS
  let today = new Date();

  let startDate = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();

  today.setDate(today.getDate() + 3);

  let endDate = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
  // #########################################################

  fetch("https://api.ruralclima.app/auth/signin", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      username: "apicoopernorte",
      password: "C3ap5sgvoWs6b052ny",
    }),
  })
    .then(resp => {
      console.log("RESP: ", resp);
      return resp.json();
    })
    .then(json => {
      // console.log("JSON: ", json);
      const token = json.token;

      fetch("https://api.ruralclima.app/region", {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(resp => resp.json())
        .then(data => {
          // console.log(data);

          stateSelect.addEventListener("change", e => {
            const filtered = data.filter(el => el.state == e.target.value);

            // console.log("FILTERED: ", filtered);

            let selectContent = filtered.map(el => {
              return `
              <option data-code="${el.ibgeCode}" data-city="${el.city}" value="${el.state}">${el.realName ? el.realName : el.city}</option>
              `;
            });

            citySelect.innerHTML = selectContent;
            citySelect.insertAdjacentHTML("afterbegin", '<option selected value="">Selecionar</option>');
          });

          let currentState = "PA";
          let currentCity = "Paragominas";
          let currentCode = 1505502;

          citySelect.addEventListener("change", e => {
            currentState = e.target.value;
            currentCity = e.target.options[e.target.selectedIndex].dataset.city;
            currentCode = e.target.options[e.target.selectedIndex].dataset.code;

            getForecast(token, startDate, endDate, currentState, currentCity, currentCode);
          });

          // ################## GET FORECAST
          getForecast(token, startDate, endDate, currentState, currentCity, currentCode);
          // #####################################
        });
    })
    .catch(function (res) {
      console.log(res);
    });
} // END INIT()

async function getForecast(token, startDate, endDate, state, city, code) {
  const loaderGrid = `<div class="swiper-slide">
  <div class="loader-card">
    <span class="loader"></span>
  </div>
</div>`;

  const previsaoContainer = document.querySelector(".previsao-slider .swiper-wrapper");

  previsaoContainer.innerHTML = loaderGrid;

  const resp = await fetch(
    "https://api.ruralclima.app/meteorology/forecast/daily?" +
    new URLSearchParams({
      iniDate: startDate,
      endDate: endDate,
      state: state,
      city: city,
      ibgeCode: code,
    }),
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  const data = await resp.json();

  console.log(data);

  const prevContent = data.map(el => {
    const temp_min = parseInt(el.tempMin, 10);
    const temp_max = parseInt(el.tempMax, 10);
    const rain = el.rainProbability;
    const humidity = parseInt(el.humidityMax, 10);
    const windCompass = el.windCompass;
    const windSpeed = parseInt(el.windSpeed, 10);
    const date = new Date(el.date).getUTCDate();
    const month = new Date(el.date).getMonth() + 1;
    const year = new Date(el.date).getFullYear();
    const day = new Date(el.date).getDay();

    console.log("month: ", month);

    const dayNames = ["Segunda-Feira", "Terça-Feira", "Quarta-Feira", "Quinta-Feira", "Sexta-Feira", "Sábado", "Domingo"];

    const cityName = document.querySelector(".cityName");

    cityName.innerHTML = el.realName ? el.realName : el.city;

    return `
    <div class="swiper-slide">
              <div class="prev-card">
                <div class="data">${dayNames[day]} – ${date}/${month}/${year}</div>
                <div class="temps">
                  <img src="https://hml.coopernorte.coop.br/wp-content/themes/coopernorte-theme/assets/images/ico-prev1.svg" alt="">
                  <div class="col1">
                    <div class="header"><img
                        src="https://hml.coopernorte.coop.br/wp-content/themes/coopernorte-theme/assets/images/ico-prev-down.svg" alt="">MIN
                    </div>
                    <div class="value">
                      ${temp_min} <span>°C</span>
                    </div>
                  </div>
                  <div class="col2">
                    <div class="header"><img
                        src="https://hml.coopernorte.coop.br/wp-content/themes/coopernorte-theme/assets/images/ico-prev-down.svg" alt="">MAX
                    </div>
                    <div class="value">
                    ${temp_max} <span>°C</span>
                    </div>
                  </div>

                </div>
                <div class="bottom">
                  <div>
                    <img src="https://hml.coopernorte.coop.br/wp-content/themes/coopernorte-theme/assets/images/ico-prev2.svg" alt="">
                    <div> ${rain}%</div>
                  </div>
                  <div>
                    <img src="https://hml.coopernorte.coop.br/wp-content/themes/coopernorte-theme/assets/images/ico-prev3.svg" alt="">
                    <div>${humidity}%</div>
                  </div>
                  <div>
                    <img src="https://hml.coopernorte.coop.br/wp-content/themes/coopernorte-theme/assets/images/ico-prev4.svg" alt="">
                    <div>${windCompass} ${windSpeed}km/h</div>
                  </div>
                </div>
              </div>
            </div>
    `;
  });

  previsaoContainer.innerHTML = prevContent.join(" ");

  setPrevisaoSlider();

  // return console.log(data);
}

// const btnSearch = document.querySelector(".btn-search");
// const search = document.querySelector(".search-box");

// btnSearch.addEventListener("click", e => {
//   e.preventDefault();
//   search.classList.toggle("open");
// });

function setPrevisaoSlider() {
  const HomePrevisaoSlider = document.querySelector('[data-carousel="home-previsao"]');

  if (HomePrevisaoSlider) {
    const Carousel = new Swiper(HomePrevisaoSlider, {
      speed: 400,
      // loop: true,
      slidesPerView: 4,
      slidesPerGroup: 1,
      watchOverflow: true,
      spaceBetween: 5,

      navigation: {
        nextEl: document.querySelector(".home-previsao .swiper-button-next"),
        prevEl: document.querySelector(".home-previsao .swiper-button-prev"),
      },
      pagination: {
        el: document.querySelector(".home-previsao .swiper-pagination"),
        type: "bullets",
        renderBullet: (index, className) => `<button class="${className}" type="button" aria-title="${index}">
        </button>`,
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 15,
        },
      },
    });
  }
}
